export default "__VITE_ASSET__a273e12d__"